module.exports = __webpack_public_path__ + "static/media/australia.1dc4f370.svg";